
document.addEventListener("DOMContentLoaded", function () {
  const allDetails = document.querySelectorAll(".accordion details");

  allDetails.forEach((detail) => {
    detail.addEventListener("toggle", () => {
      if (detail.open) {
        allDetails.forEach((otherDetail) => {
          if (otherDetail !== detail) {
            otherDetail.removeAttribute("open");
          }
        });
      }
    });
  });
});


